import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { OptimizedImage } from './OptimizedImage';

export const ServiceCard = ({ service, index = 0 }) => {
  const items = service.covers || [];

  return (
    <Link to={`/hizmetler/${service.id}`} aria-label={`${service.title} tedavi detayı`} className="block" data-testid="service-card">
      <motion.div
        className="group bg-white rounded-[20px] border border-[#E7E5E4] overflow-hidden shadow-[0_4px_16px_-8px_rgba(0,0,0,0.08)] transition-all hover:border-[#1F6E7A]/30 hover:shadow-[0_8px_28px_-8px_rgba(31,110,122,0.15)] flex flex-col sm:flex-row"
        whileHover={{ y: -4 }}
        transition={{ type: 'spring', stiffness: 300 }}
      >
        {/* Image - left side */}
        {service.image && (
          <div className="sm:w-[280px] md:w-[320px] shrink-0 aspect-[16/10] sm:aspect-auto overflow-hidden">
            <OptimizedImage
              src={service.image}
              alt={service.title}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              sizes="(max-width: 640px) 100vw, 320px"
            />
          </div>
        )}

        {/* Content - right side */}
        <div className="p-5 sm:p-6 flex-1 flex flex-col">
          <h3 className="font-heading font-semibold text-[24px] leading-tight mb-2">{service.title}</h3>
          <p className="text-[14px] text-[#5F6B76] leading-relaxed mb-4">{service.short}</p>

          {items.length > 0 && (
            <div className="pt-4 border-t border-[#F0EDEA]">
              <div className="space-y-2">
                {items.slice(0, 4).map((w, i) => (
                  <div key={i} className="flex items-start gap-2.5 text-[14px] text-[#5F6B76]">
                    <CheckCircle size={18} className="text-[#1F6E7A] mt-1 shrink-0" />
                    <span>{w}</span>
                  </div>
                ))}
                {items.length > 4 && (
                  <span className="text-[14px] text-[#1F6E7A] font-medium">+{items.length - 4} daha</span>
                )}
              </div>
            </div>
          )}

          <div className="flex items-center gap-1.5 mt-4 text-[14px] font-semibold text-[#1F6E7A] group-hover:gap-2.5 transition-all">
            Detayları İncele <ArrowRight size={16} />
          </div>
        </div>
      </motion.div>
    </Link>
  );
};
